import { render, staticRenderFns } from "./TimeMessage.vue?vue&type=template&id=0f562e9a&scoped=true&"
import script from "./TimeMessage.vue?vue&type=script&lang=js&"
export * from "./TimeMessage.vue?vue&type=script&lang=js&"
import style0 from "./TimeMessage.vue?vue&type=style&index=0&id=0f562e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f562e9a",
  null
  
)

export default component.exports